export default "__VITE_ASSET__BoGFFZSK__"